export default function($) {
  const swiper = new Swiper('.js-gallery-carousel', {
    loop: true,
    spaceBetween: 10,
    slidesPerView: 'auto',
    centeredSlides: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    on: {
      init: setSlideWidth,
      resize: setSlideWidth,
    }
  });

  function setSlideWidth() {
    const slides = $('.js-gallery-carousel').find('.swiper-slide'),
          sliderHeight = $('.js-gallery-carousel .swiper-wrapper').height();

    $('.js-gallery-carousel .swiper-slide img').each(function() {
      let oWidth = $(this).data('width'),
          oHeight = $(this).data('height');

      let resizedWidth = sliderHeight * oWidth / oHeight;
      $(this).css('width', resizedWidth + 'px');
    });

    const totalSlideWidth = calculateTotalSlideWidth(slides);
    const viewportSize = $(window).width();

    if (totalSlideWidth < viewportSize) {
      duplicateSlides(viewportSize, totalSlideWidth, slides);
    }
  }

  function calculateTotalSlideWidth(slides) {
    let totalWidth = 0;

    slides.each(function () {
      totalWidth += $(this).outerWidth(true);
    });

    return totalWidth;
  }

  function duplicateSlides(viewportSize, totalSlideWidth, slides) {
    const slidesArray = Array.from(slides);

    while (totalSlideWidth < viewportSize) {
      slidesArray.forEach(slide => {
        const clone = slide.cloneNode(true);
        $('.swiper-wrapper').append(clone);

        totalSlideWidth += $(clone).outerWidth(true);
      });
    }
  }
}
